import { createBrowserHistory } from "history";
import React, { Suspense, useEffect, useRef, useState } from "react";
import { withResizeDetector } from "react-resize-detector";
import { useHistory } from "react-router";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import NavbarLanding from "../src/jsx/pages/navlanding-component";
import "./css/basic.css";
import "./css/style.css";
import ManageNodes from "./jsx/components/Node/ManageNodes";
// Css
import "./index.css";
import ManageNodeCard from "./jsx/components/Node/NodeCards/ManageNodeCards";
import PrivateRoute from "./jsx/components/PrivateRoute";
import ManageUserGroup from "./jsx/components/UserGroup/ManageUserGroup";
import Footer from "./jsx/layouts/Footer";
// Layout
import { css } from "@emotion/react";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import SquareLoader from "react-spinners/SquareLoader";
import "./css/log.css";
import Nav from "./jsx/layouts/nav";
import Error404 from "./jsx/pages/Error404";
import "./scss/styles/styles.css";

const ManageFW = React.lazy(() => import("./jsx/components/Node/FW/ManageFW"));
const ManageCustomActions = React.lazy(() =>
  import("./jsx/components/Node/CustomActions/ManageCustomActions")
);

const ManageTaskComponent = React.lazy(() =>
  import("./jsx/components/Task/ManageTask-component")
);

const ManageCTaskComponent = React.lazy(() =>
  import("./jsx/components/Task/ManageCTask-component")
);

const UserProfileComponent = React.lazy(() =>
  import("./jsx/components/Profile/UserProfile-component")
);

const Dashboard = React.lazy(() => import("./jsx/components/Dashboard"));

const UserList = React.lazy(() =>
  import("./jsx/components/UserGroup/UserList-component")
);

const UserJoinPendingComponent = React.lazy(() =>
  import("./jsx/components/UserGroup/UserJoinPending-component")
);

const ManageOrg = React.lazy(() =>
  import("./jsx/components/Organization/ManageOrg")
);

const SettingProvisionComponent = React.lazy(() =>
  import("./jsx/components/Set/SettingProvision-home")
);

const NodeJoinPending = React.lazy(() =>
  import("./jsx/components/Node/NodeJoinPending")
);

const Action = React.lazy(() =>
  import("./jsx/components/Node/Actions/ActionPage")
);

const HostInfo = React.lazy(() =>
  import("./jsx/components/Node/HostInfo/HostInfoMain")
);

const License = React.lazy(() => import("./jsx/components/Main/License"));
const LoginComponent = React.lazy(() => import("./jsx/pages/login-component"));
const Help = React.lazy(() => import("./jsx/components/Main/Help"));
const NodeStatus = React.lazy(() => import("./jsx/components/Node/NodeStatus"));
const Contact = React.lazy(() => import("./jsx/components/Main/Contact"));
const RestPassword = React.lazy(() => import("./jsx/pages/ResetPassword"));

const LogActivity = React.lazy(() =>
  import("./jsx/components/LogReport/MyLog")
);

const OrgLogActivity = React.lazy(() =>
  import("./jsx/components/LogReport/OrgLog")
);

const NodeGroupLog = React.lazy(() =>
  import("./jsx/components/LogReport/NodeGroupLog")
);

const UserGroupLog = React.lazy(() =>
  import("./jsx/components/LogReport/UserGroupLog")
);

const GroupLogBoard = React.lazy(() =>
  import("./jsx/components/LogReport/GroupLogDetailBoard")
);

const NotificationSetting = React.lazy(() =>
  import("./jsx/components/Set/notification/NotificationSetting")
);

const LineScreenshot = React.lazy(() =>
  import("./jsx/pages/lineLiff/LineScreenshot")
);
// const LineScreenshot1 = React.lazy(() =>
//   import("./jsx/pages/lineLiff/LineScreenshot2")
// );

const LinePowerCycle = React.lazy(() =>
  import("./jsx/pages/lineLiff/LinePowerCycle")
);

const LineNodeStatus = React.lazy(() =>
  import("./jsx/pages/lineLiff/LineNodeStatus")
);

const LiffBindPage = React.lazy(() =>
  import("./jsx/pages/lineLiff/LiffBindPage")
);

const ServerTransfer = React.lazy(() =>
  import("./jsx/components/ServerTransfer/ServerTransfer")
);

const TransferGuide = React.lazy(() =>
  import("./jsx/components/ServerTransfer/TransferGuide")
);

const ManualSelection = React.lazy(() =>
  import("./jsx/components/ServerTransfer/ManualSelection")
);

const SharedDBTransfer = React.lazy(() =>
  import("./jsx/components/ServerTransfer/SharedDBTransfer")
);

const TransferSetup = React.lazy(() =>
  import("./jsx/components/ServerTransfer/TransferSetup")
);

const CloneDBTransfer = React.lazy(() =>
  import("./jsx/components/ServerTransfer/CloneDBTransfer")
);

const CloneDBStep1 = React.lazy(() =>
  import("./jsx/components/ServerTransfer/CloneDBStep1")
);
const CloneDBStep2 = React.lazy(() =>
  import("./jsx/components/ServerTransfer/CloneDBStep2")
);
const CloneDBStep3 = React.lazy(() =>
  import("./jsx/components/ServerTransfer/CloneDBStep3")
);
const CloneDBStep3Help = React.lazy(() =>
  import("./jsx/components/ServerTransfer/CloneDBStep3Help")
);
const CloneDBTransferSetup = React.lazy(() =>
  import("./jsx/components/ServerTransfer/CloneDBTransferSetup")
);
const CloneDBTransferSetupDifferent = React.lazy(() =>
  import("./jsx/components/ServerTransfer/CloneDBTransferSetupDifferent")
);
const RootServerTransferGuide = React.lazy(() =>
  import("./jsx/components/ServerTransfer/RootServerTransferGuide")
);
const RootTransferGuideStep1 = React.lazy(() =>
  import("./jsx/components/ServerTransfer/RootTransferGuideStep1")
);
const RootTransferGuideStep2 = React.lazy(() =>
  import("./jsx/components/ServerTransfer/RootTransferGuideStep2")
);
const RootTransferGuideStep3 = React.lazy(() =>
  import("./jsx/components/ServerTransfer/RootTransferGuideStep3")
);
const RootTransferGuideStep4 = React.lazy(() =>
  import("./jsx/components/ServerTransfer/RootTransferGuideStep4")
);
const RootTransferGuideStep5 = React.lazy(() =>
  import("./jsx/components/ServerTransfer/RootTransferGuideStep5")
);
const RootTransferSubmissionsDashboard = React.lazy(() =>
  import("./jsx/components/ServerTransfer/RootTransferSubmissionsDashboard")
);
const override = css`
  display: block;
  margin: 0 auto;
  ${"" /* border-color: "#1FABAA"; */}
`;

const App = ({ width }) => {
  const history = useHistory();
  const body = document.querySelector("body");
  const [progress, setProgress] = useState(0);
  const previousScrollY = useRef();
  const [scrollDirection, setScrollDirection] = useState("down");
  const [scrollY, setScrollY] = useState(0);
  const [loginStatus, setLoginStatus] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [loading, setLoading] = useState(true);
  const [color, setColor] = useState("#1FABAA");
  const [selectGroupLoad, setSelectGroupLoad] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    function listener() {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      setScrollY(scrollTop);
      setProgress(
        scrollTop / (document.documentElement.offsetHeight - window.innerHeight)
      );

      const direction = previousScrollY.current < scrollTop ? "down" : "up";
      setScrollDirection(direction);
    }

    function onTouchStart() {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      setScrollY(scrollTop);
      setProgress(
        scrollTop / (document.documentElement.offsetHeight - window.innerHeight)
      );

      const direction = previousScrollY.current < scrollTop ? "down" : "up";
      setScrollDirection(direction);
    }

    window.addEventListener("scroll", listener, { passive: true });

    document.addEventListener("touchstart", onTouchStart, {
      passive: true,
    });

    return () => {
      window.removeEventListener("scroll", listener, { passive: true });
      window.removeEventListener("touchstart", onTouchStart, { passive: true });
    };
  }, []);

  useEffect(() => {
    if (selectGroupLoad) {
      setFadeOut(true);
      setTimeout(() => {
        setSelectGroupLoad(false);
        setFadeOut(false);
      }, 2500);
    }
  }, [selectGroupLoad]);

  const routes = [
    { url: "manage-org", component: ManageOrg },
    {
      url: "root-server-transfer/dashboard",
      component: RootTransferSubmissionsDashboard,
    },
    {
      url: "root-server-transfer/guide/step5",
      component: RootTransferGuideStep5,
    },
    {
      url: "root-server-transfer/guide/step4",
      component: RootTransferGuideStep4,
    },
    {
      url: "root-server-transfer/guide/step3",
      component: RootTransferGuideStep3,
    },
    {
      url: "root-server-transfer/guide/step2",
      component: RootTransferGuideStep2,
    },
    {
      url: "root-server-transfer/guide/step1",
      component: RootTransferGuideStep1,
    },
    { url: "root-server-transfer", component: RootServerTransferGuide },
    { url: "dashboard", component: Dashboard },
    { url: "manage-usergroup", component: ManageUserGroup },
    { url: "node-status", component: NodeStatus },
    { url: "manage-nodes", component: ManageNodes },
    { url: "manage-fw", component: ManageFW },
    { url: "custom-actions", component: ManageCustomActions },
    { url: "nodes-joinpending", component: NodeJoinPending },
    { url: "user-list", component: UserList },
    { url: "userjoin-pending", component: UserJoinPendingComponent },
    { url: "user-profile", component: UserProfileComponent },
    { url: "manage-task", component: ManageTaskComponent },
    { url: "manage-ctask", component: ManageCTaskComponent },
    { url: "setting-provision", component: SettingProvisionComponent },
    { url: "contact", component: Contact, isPublic: true },
    { url: "error-404", component: Error404, isPublic: true },
    { url: "help", component: Help },
    { url: "license", component: License, isPublic: true },
    { url: "manage-node-cards", component: ManageNodeCard },
    { url: "actions/:nodeId?", component: Action },
    { url: "hostInfo", component: HostInfo },
    { url: "notification-setting", component: NotificationSetting },
    { url: "reset-password", component: RestPassword, isPublic: true },
    { url: "activity-logs", component: LogActivity },
    { url: "organization-logs", component: OrgLogActivity },
    { url: "node-group-logs", component: NodeGroupLog },
    { url: "user-group-logs", component: UserGroupLog },
    { url: ":source/group-logs-details/:id", component: GroupLogBoard },
    { url: "liff/scrn", component: LineScreenshot, isPublic: true },
    { url: "liff/powercycle", component: LinePowerCycle, isPublic: true },
    { url: "liff/nodestatus", component: LineNodeStatus, isPublic: true },
    { url: "liff", component: LiffBindPage, isPublic: true },
    { url: "server-transfer/guide", component: TransferGuide },
    { url: "server-transfer/manual", component: ManualSelection },
    { url: "server-transfer/setup/shared-db", component: SharedDBTransfer },
    { url: "server-transfer/setup", component: TransferSetup },
    { url: "server-transfer/clone-db/step1", component: CloneDBStep1 },
    { url: "server-transfer/clone-db/step2", component: CloneDBStep2 },
    { url: "server-transfer/clone-db/step3/help", component: CloneDBStep3Help },
    {
      url: "server-transfer/clone-db/step3/transfer-setup-different",
      component: CloneDBTransferSetupDifferent,
    },
    {
      url: "server-transfer/clone-db/step3/transfer-setup",
      component: CloneDBTransferSetup,
    },
    { url: "server-transfer/clone-db/step3", component: CloneDBStep3 },
    { url: "server-transfer/clone-db", component: CloneDBTransfer },
    { url: "server-transfer", component: ServerTransfer },
  ];

  width >= 1300
    ? body.setAttribute("data-sidebar-style", "full")
    : width <= 1299 && width >= 767
    ? body.setAttribute("data-sidebar-style", "mini")
    : body.setAttribute("data-sidebar-style", "overlay");

  return (
    <>
      {/* <div className="test_env">For Frontend & Backend Test</div> */}

      <div
        id="overlay"
        className={`loader-container ${fadeOut ? "fade-out" : ""}`}
        style={{ visibility: selectGroupLoad ? "" : "hidden" }}
      >
        {" "}
        <div className="loader-container">
          <SquareLoader
            color={color}
            loading={loading}
            css={override}
            size={50}
          />
          <p className="loading-text">Loading...</p>
        </div>
      </div>

      <Router history={history} basename="/">
        {/* <RouteChangeHandler /> */}
        <div id="main-wrapper" className="show">
          <div id="nav-display" className="nav-display">
            <Nav
              login={[loginStatus, setLoginStatus]}
              reloadTest={[refreshKey, setRefreshKey]}
              load={[selectGroupLoad, setSelectGroupLoad]}
            />
          </div>
          <div id="content-body" className="content-body">
            <div id="container-fluid" className="container-fluid">
              <Suspense fallback={<div>Loading...</div>}>
                <Switch>
                  {routes.map((data) => {
                    const RouteComponent = data.isPublic
                      ? Route
                      : PrivateRoute;
                    return (
                      <RouteComponent
                        key={`${data.url}-${refreshKey}`}
                        exact
                        path={`/${data.url}`}
                        component={data.component}
                      />
                    );
                  })}

                  <Route path="/" exact>
                    <NavbarLanding />
                    <LoginComponent setLoginStatus={setLoginStatus} />
                  </Route>

                  <Route path="/liff/bindsuccess" exact>
                    <LiffBindPage />
                  </Route>

                  <Route component={Error404} />
                </Switch>
              </Suspense>
            </div>
          </div>
          <Suspense fallback={<div>Loading...</div>}>
            <Footer />
          </Suspense>
        </div>
      </Router>
    </>
  );
};

export default withResizeDetector(App);
export const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL,
});
